import React from "react"

export function Minus({ fill = "#FF46AA", h = 12, w = 12 }: { fill?: string; h?: number; w?: number }) {
  return (
    <svg width={w} height={h} viewBox="0 0 12 3" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M0 1.2C0 0.537258 0.383756 0 0.857143 0H11.1429C11.6162 0 12 0.537258 12 1.2C12 1.86274 11.6162 2.4 11.1429 2.4H0.857143C0.383756 2.4 0 1.86274 0 1.2Z" fill={fill}/>
    </svg>
  )
}
